export default "__VITE_ASSET__aa315298__"